import { render, staticRenderFns } from "./challengeDetail.vue?vue&type=template&id=562ec847&scoped=true&"
import script from "./challengeDetail.vue?vue&type=script&lang=js&"
export * from "./challengeDetail.vue?vue&type=script&lang=js&"
import style0 from "./challengeDetail.vue?vue&type=style&index=0&id=562ec847&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562ec847",
  null
  
)

export default component.exports